import { createElement } from "@max/max";
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
const GradientText = (props) => {
    const { text } = props;
    return <View>
      <Text className="gradient-text">{text}</Text>
    </View>;
};
export default GradientText;
